import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_SCHEDULE,
  GET_SCHEDULE_BY_ID,
  CREATE_SCHEDULE,
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULE_REALIZED,
  DELETE_SCHEDULE,
} from './actionType';

const INIT_STATE = {
  schedule: [],
  scheduleById: {},
  error: {},
  success: null,
};

const Schedule = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SCHEDULE:
          return {
            ...state,
            schedule: action.payload.data,
            success: null,
            error: {},
            scheduleById: {},
          };
        case GET_SCHEDULE_BY_ID:
          return {
            ...state,
            scheduleById: action.payload.data,
            success: null,
            error: {},
          };
        case CREATE_SCHEDULE:
          return {
            ...state,
            success: 'Successfully created schedule',
            error: {},
          };
        case UPDATE_SCHEDULE:
          return {
            ...state,
            success: 'Successfully updated schedule',
            error: {},
          };
        case UPDATE_SCHEDULE_REALIZED:
          return {
            ...state,
            success: 'Successfully updated schedule realized',
            error: {},
          };
        case DELETE_SCHEDULE:
          return {
            ...state,
            success: 'Successfully deleted schedule',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_SCHEDULE:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case GET_SCHEDULE_BY_ID:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_SCHEDULE:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_SCHEDULE:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_SCHEDULE_REALIZED:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_SCHEDULE: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }
    case GET_SCHEDULE: {
      return {
        ...state,
      };
    }
    case GET_SCHEDULE_BY_ID: {
      return {
        ...state,
      };
    }
    case CREATE_SCHEDULE: {
      return {
        ...state,
      };
    }
    case UPDATE_SCHEDULE: {
      return {
        ...state,
      };
    }
    case UPDATE_SCHEDULE_REALIZED: {
      return {
        ...state,
        scheduleById: {},
      };
    }
    case DELETE_SCHEDULE: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Schedule;
